import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import "@/index.css";

import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { I18nProvider } from "./contexts/I18nContext";
import { ActiveGroupProvider } from "./contexts/ActiveGroupContext";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import MobileShell from "./components/MobileShell";
import MyTips from "./pages/MyTips";
import Groups from "./pages/Groups";
import GroupDetail from "./pages/GroupDetail";
import Leaderboard from "./pages/Leaderboard";
import Rules from "./pages/Rules";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Standings from "./pages/Standings";
import { Toaster } from "@/components/ui/toaster";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#02371b] text-white flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white/20 border-t-[#41a42b] rounded-full animate-spin" />
      </div>
    );
  }
  
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  
  if (code) {
    localStorage.setItem('pendingInviteCode', code);
    if (user) {
      return <Navigate to="/app" replace />;
    }
  }
  
  if (!user) {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <MobileShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<MyTips />} />
        <Route path="groups" element={<Groups />} />
        <Route path="groups/:groupId" element={<GroupDetail />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="rules" element={<Rules />} />
        <Route path="standings" element={<Standings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <ActiveGroupProvider>
            <AppRouter />
            <Toaster />
          </ActiveGroupProvider>
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
